import { useCallback, useMemo } from "react";
export const useCategoryTree = (param)=>{
    let { categoryMenu , categoryId  } = param;
    const currentDepth = useMemo(()=>{
        if (!categoryId) return 1;
        return categoryId.length / 2;
    }, [
        categoryId
    ]);
    const convertCategoryToTreeData = useCallback((category)=>{
        if (!category) return [];
        const convertItems = (items)=>{
            return items.map((item)=>{
                return {
                    id: item.id,
                    label: item.name,
                    children: item.items ? convertItems(item.items) : []
                };
            });
        };
        return convertItems(category.items);
    }, []);
    const findCategoryChildren = useCallback((depth, id)=>{
        if (!categoryMenu) return null;
        const currentId = id || categoryId;
        let currentItems = categoryMenu.depthItems;
        let currentIdSlice = "";
        for(let i = 1; i <= depth; i++){
            currentIdSlice = currentId.slice(0, i * 2).toString();
            const currentCategory = currentItems.find((item)=>item.id === currentIdSlice);
            if (!currentCategory) return null;
            if (i === depth) return currentCategory;
            currentItems = currentCategory.items;
        }
        return null;
    }, [
        categoryId,
        categoryMenu
    ]);
    const findCategoryDepthNameWithIds = useCallback(()=>{
        if (!categoryMenu) return [];
        if (!categoryId) return [
            {
                name: findCategoryChildren(1).name,
                id: findCategoryChildren(1).id
            }
        ];
        const findCategory = function(items) {
            let depthNames = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
            for(let i = 0; i < items.length; i++){
                if (items[i].id === categoryId) return [
                    ...depthNames,
                    {
                        name: items[i].name,
                        id: items[i].id
                    }
                ];
                if (items[i].items) {
                    const found = findCategory(items[i].items, [
                        ...depthNames,
                        {
                            name: items[i].name,
                            id: items[i].id
                        }
                    ]);
                    if (found) return found;
                }
            }
        };
        return findCategory(categoryMenu.depthItems) || [];
    }, [
        categoryMenu,
        categoryId
    ]);
    const isLastDepth = useMemo(()=>{
        var _findCategoryChildren, _findCategoryChildren1;
        return ((_findCategoryChildren = findCategoryChildren(currentDepth)) === null || _findCategoryChildren === void 0 ? void 0 : _findCategoryChildren.items) ? ((_findCategoryChildren1 = findCategoryChildren(currentDepth)) === null || _findCategoryChildren1 === void 0 ? void 0 : _findCategoryChildren1.items.length) === 0 : true;
    }, [
        categoryId,
        categoryMenu
    ]);
    const checkLastDepth = useCallback((id)=>{
        var _findCategoryChildren, _findCategoryChildren1;
        return ((_findCategoryChildren = findCategoryChildren(id.length / 2, id)) === null || _findCategoryChildren === void 0 ? void 0 : _findCategoryChildren.items) ? ((_findCategoryChildren1 = findCategoryChildren(id.length / 2, id)) === null || _findCategoryChildren1 === void 0 ? void 0 : _findCategoryChildren1.items.length) === 0 : true;
    }, [
        categoryMenu,
        categoryId
    ]);
    return {
        treeData: convertCategoryToTreeData(findCategoryChildren(1)),
        findCategoryChildren,
        categoryDepthNameList: findCategoryDepthNameWithIds(),
        currentDepth,
        isLastDepth,
        checkLastDepth
    };
};
